import { z } from 'zod';

export type ApiErrorResponse = {
	type: string;
	title: string;
	detail: string;
	status: number;
	traceId: string;
};

export type ApiUnexpectedErrorResponse = {
	type: string;
	title: string;
	status: number;
	errors: Record<string, string[]>;
	traceId: string;
};

export const apiErrorResponseSchema: z.ZodType<ApiErrorResponse> = z.object({
	type: z.string(),
	title: z.string(),
	detail: z.string(),
	status: z.number(),
	traceId: z.string(),
});

export const apiUnexpectedErrorResponseSchema: z.ZodType<ApiUnexpectedErrorResponse> = z.object({
	type: z.string(),
	title: z.string(),
	errors: z.record(z.string(), z.array(z.string())),
	status: z.number(),
	traceId: z.string(),
});

export const getApiErrorMessage = (input: unknown): string | null => {
	const apiErrorResponseParseResult = apiErrorResponseSchema.safeParse(input);
	return apiErrorResponseParseResult.data?.detail ?? null;
};

export const getApiErrorTraceId = (input: unknown): string | null => {
	const traceIdParseResult = z.object({ traceId: z.string() }).safeParse(input);
	return traceIdParseResult.data?.traceId ?? null;
};

export const getErrorMessage = (input: unknown): string => {
	const apiErrorResponseParseResult = getApiErrorMessage(input);

	if (apiErrorResponseParseResult) {
		return apiErrorResponseParseResult;
	}

	const apiUnexpectedErrorParseResult = apiUnexpectedErrorResponseSchema.safeParse(input);

	if (apiUnexpectedErrorParseResult.data) {
		return Object.entries(apiUnexpectedErrorParseResult.data.errors)
			.map(([key, value]) => `${key}: ${value.join(', ')}`)
			.join(';');
	}

	if (input instanceof Error) {
		return input.message;
	}

	if (typeof input === 'object') {
		return JSON.stringify(input);
	}

	return String(input);
};
